import { configureStore } from '@reduxjs/toolkit';
import reducer from './autoshipSlice';

const store = configureStore({ reducer });

export default store;
